"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuContent = function MenuContent(_ref) {
  var opened = _ref.opened,
      handleOpenClose = _ref.handleOpenClose,
      children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["opened", "handleOpenClose", "children", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledMenuContent, _extends({
    className: className
  }, otherProps), children);
};

exports.MenuContent = MenuContent;

var StyledMenuContent = _styledComponents.default.div.withConfig({
  displayName: "StyledMenuContent"
})(["flex:1 0 auto;padding:2rem;background-color:#fbfbfb;overflow-y:scroll;"]);

MenuContent.propTypes = {
  opened: _propTypes.bool,
  handleOpenClose: _propTypes.func,
  children: _propTypes.node.isRequired,
  className: _propTypes.string,
  otherProps: _propTypes.object
};